import axios from 'axios'
import qs from 'qs'

const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
  setTimeout(() => reject(TIMEOUT), 10e3)

export default {
  getOfflineService (appId) {
    const url = '/dashboard/business/v1/info?appId=' + appId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
}



// WEBPACK FOOTER //
// ./app/api/system.js